import OnDemandRevenueModule from "./onDemandRevenueModule";
import OnDemandRevenueSagas from "./redux/onDemandRevenueSagas";
import OnDemandRevenueReducer from "./redux/onDemandRevenueReducer";

export default {
  Component: OnDemandRevenueModule,
  moduleName: "onDemandRevenue",
  saga: OnDemandRevenueSagas(),
  reducer: OnDemandRevenueReducer
};
